import { ActiveMessage as UseCaseReduxActiveMessage } from '../../../../domain/usecases/message/redux';

import { ReduxActiveMessage } from '../../../../data/store/reducer/message/usecases/ReduxActiveMessage';

/**
 * send request via REDUX.
 */
export const makeReduxActiveMessage = (): UseCaseReduxActiveMessage =>
  new ReduxActiveMessage();
